import { useNgSession } from "@sazka/ng/ng-session";
import { ref } from "vue";

const showSuccess = ref(false);
const isMultibetPage = ref(false);
const betPrice = ref(-1);
const betWagerId = ref(-1);
const betWagerIds = ref<number[]>([]);
const isSubscription = ref(false);
const subscriptionId = ref(-1);
const balanceAfterBet = ref<number>();

const { balanceNumeric } = useNgSession();

export default function useBetSuccess() {
    const toggleShowSuccess = ({
        price = -1,
        wagerId = -1,
        isMultibetPageBet = false,
        isSubscriptionBet = false,
        subscriptionIdBet = -1,
        wagerIds = [],
    } = {}) => {
        showSuccess.value = !showSuccess.value;
        betPrice.value = price;
        betWagerId.value = wagerId;
        betWagerIds.value = wagerIds;
        isMultibetPage.value = isMultibetPageBet;
        isSubscription.value = isSubscriptionBet;
        subscriptionId.value = subscriptionIdBet;
        balanceAfterBet.value = balanceNumeric.value / 100 - price;
    };

    return {
        toggleShowSuccess,
        showSuccess,
        betPrice,
        betWagerId,
        betWagerIds,
        multibetbetPage: isMultibetPage,
        isSubscription,
        subscriptionId,
        balanceAfterBet,
    };
}
